module.exports = __webpack_public_path__ + "img/full.c3e3b8e2.png";